import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { Button } from '@/components/shadcn/button'
import {
  DMP_CHAT_MOCK_SCENARIO_OPTIONS,
  isDmpChatMockScenario,
  type DmpChatMockScenario,
} from '../fixtures/dmpChatFixtures'

export function DmpChatMockMenu({
  scenario,
  onScenarioChange,
  disabled,
}: {
  scenario: DmpChatMockScenario
  onScenarioChange: (scenario: DmpChatMockScenario) => void
  disabled: boolean
}) {
  const selectedOption = DMP_CHAT_MOCK_SCENARIO_OPTIONS.find((option) => option.value === scenario)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label={`Mock response: ${selectedOption?.label ?? 'Success stream'}`}
          disabled={disabled}
          size="sm"
          variant="outline"
        >
          <span className="hidden sm:inline">Mock: </span>
          {selectedOption?.label ?? 'Success stream'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Mock response scenario</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          onValueChange={(value) => {
            if (isDmpChatMockScenario(value)) {
              onScenarioChange(value)
            }
          }}
          value={scenario}
        >
          {DMP_CHAT_MOCK_SCENARIO_OPTIONS.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              <span>
                <span className="block">{option.label}</span>
                <span className="block text-xs text-muted-foreground">{option.description}</span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
